import React from 'react';
import { Modal } from './ui/Modal';
import { Candidate } from '../types/hr.types';
import { User, Briefcase, MapPin, ChevronRight } from 'lucide-react';
interface DrilldownModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  candidates: Candidate[];
  onCandidateClick?: (c: Candidate) => void;
}
const STATUS_COLOR: Record<string, string> = {
  'Phone Screen': 'bg-purple-100 text-purple-700',
  'In Person Interview': 'bg-orange-100 text-orange-700',
  'Offer Sent': 'bg-blue-100 text-blue-700',
  'Waiting on Response': 'bg-blue-100 text-blue-700',
  'Offer Accepted': 'bg-green-100 text-green-700',
  'Pre-boarding': 'bg-green-100 text-green-700',
  'Ready to Start': 'bg-emerald-100 text-emerald-700',
  'Offer Declined': 'bg-red-100 text-red-700',
  'Follow Up Later': 'bg-amber-100 text-amber-700',
  'Hired Elsewhere': 'bg-gray-100 text-gray-700',
  Declined: 'bg-red-100 text-red-700'
};
export function DrilldownModal({
  isOpen,
  onClose,
  title,
  subtitle,
  candidates,
  onCandidateClick
}: DrilldownModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth="3xl" data-id="element-890">
      <div className="flex flex-col max-h-[70vh]" data-id="element-891">
        {/* Header summary */}
        <div className="mb-4 pb-4 border-b border-gray-100" data-id="element-892">
          <div className="flex items-baseline justify-between gap-3" data-id="element-893">
            <p className="text-sm text-gray-500" data-id="element-894">
              {subtitle || `Candidates that make up this metric`}
            </p>
            <p className="text-sm font-semibold text-gray-900" data-id="element-895">
              {candidates.length}{' '}
              {candidates.length === 1 ? 'candidate' : 'candidates'}
            </p>
          </div>
        </div>

        {/* List */}
        <div className="flex-1 overflow-y-auto" data-id="element-896">
          {candidates.length === 0 ? <div className="text-center py-12 text-gray-400 text-sm" data-id="element-897">
              No candidates match this metric.
            </div> : <ul className="space-y-2" data-id="element-898">
              {candidates.map(c => {
            const statusCls = STATUS_COLOR[c.status] || 'bg-gray-100 text-gray-700';
            return <li key={c.id} onClick={() => onCandidateClick && onCandidateClick(c)} className={`flex items-center gap-4 p-3 border border-gray-100 rounded-lg ${onCandidateClick ? 'hover:border-orange-200 hover:bg-orange-50/40 cursor-pointer' : ''} transition-colors`} data-id="element-899">
                    <div className="h-9 w-9 rounded-full bg-orange-100 text-orange-700 flex items-center justify-center text-xs font-semibold flex-shrink-0" data-id="element-900">
                      {c.firstName[0]}
                      {c.lastName[0]}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-901">
                      <p className="text-sm font-semibold text-gray-900 truncate" data-id="element-902">
                        {c.firstName} {c.lastName}
                      </p>
                      <div className="flex items-center gap-3 text-xs text-gray-500 mt-0.5" data-id="element-903">
                        <span className="inline-flex items-center gap-1 truncate" data-id="element-904">
                          <Briefcase className="h-3 w-3" data-id="element-905" />
                          {c.role}
                        </span>
                        <span className="inline-flex items-center gap-1" data-id="element-906">
                          <MapPin className="h-3 w-3" data-id="element-907" />
                          {c.branch}
                        </span>
                        {c.recruiter && <span className="inline-flex items-center gap-1 truncate" data-id="element-908">
                            <User className="h-3 w-3" data-id="element-909" />
                            {c.recruiter}
                          </span>}
                      </div>
                    </div>
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${statusCls} whitespace-nowrap`} data-id="element-910">
                      {c.status}
                    </span>
                    {onCandidateClick && <ChevronRight className="h-4 w-4 text-gray-300 flex-shrink-0" data-id="element-911" />}
                  </li>;
          })}
            </ul>}
        </div>
      </div>
    </Modal>;
}